import {ServiceGlobal} from './service.global';
import {Injectable} from '@angular/core';
import 'rxjs/add/operator/toPromise';
import {API} from '../../config/api';
import {GlobalFunction} from '../core/global_function';


@Injectable()

export class AuthenticateService extends ServiceGlobal {
    email: string;
    password: string;
    remember_me: boolean = false;
    dbname() {
        return 'cyber_northstar';
    }
    tableName() { return 'user'; }

    attributeLabels() {
        return Object.assign(super.attributeLabels(), {
            email: 'Email',
            password: 'Password',
            remember_me: 'Remember Me',
        });
    }

    rule() {
        return Object.assign(super.rule(), {
            "email": {
                "type": "string",
                "require": {
                    "empty": true,
                    "size": 100,
                    "email": true,
                },
            },
            "password": {
                "type": "string",
                "require": {
                    "empty": true,
                    "size": 100,
                    // "password": true,
                },
            },
            "remember_me": {
                "type": "int",
            },
        });
    }

    login() {
        var attr = this.getAttributesNotEmpty();
        let data_post: any = {
            grant_type: 'password',
            audience: 'tuf.joyaether.com',
            username: attr['email'],
            password: attr['password'],
        };
        data_post = GlobalFunction.get_url_param_by_object(data_post);
        return this._db.post(API.LOGIN, data_post).then(res => {
            return this.afterLoginSuccess(res, attr['email']);
        });
    }

    authenicateFromELearning(username: string, token: string) {
        let data_post: any = {
            username,
            token,
            audience: 'tuf.joyaether.com'
        };
        data_post = GlobalFunction.get_url_param_by_object(data_post);
        return this._db.postWithClientCredentialAuth(API.LOGIN_FROM_E_LEARNING, data_post).then(res => {
            // There is a bug in the server where the access token of client credential
            // is the same as the user token (probably because the timestamp is ery similar).
            // Workround the problem by refreshing the user token immediately.
            localStorage.setItem('refresh_token', res.refresh_token);
            return GlobalFunction.setTimeout(1000).then(() => {
                return this._db.refreshToken();
            }).then(refreshRes => {
                return this.afterLoginSuccess(refreshRes, username);
            });
        });
    }

    protected afterLoginSuccess(res: any, username: string) {
        let result = res;
        if(res.access_token) {
            localStorage.setItem('expires_in', res.expires_in);
            localStorage.setItem('refresh_token', res.refresh_token);
            localStorage.setItem('last_time_login', String(new Date().getTime()));
            localStorage.setItem('token', res.access_token);
            localStorage.setItem('password_token', JSON.stringify(res));

            //GlobalFunction.createCookie('token',res.access_token, res.expires_in || 1);
            // set authen_password token
            //GlobalFunction.createCookie('password_token', JSON.stringify(res), res.expires_in || 1);
            // get user info
            let api_get_user = API.GET_USER_INFO.replace("{username}", username);
            let header = this._db.getHeader();
            let pw_token = GlobalFunction.get_password_token();
            header.set('Accept', 'application/json');
            header.set('Authorization', pw_token);
            this._db.setHeader(header);
            res.code = 200;
            result = this._db.get(api_get_user).then(r => {
                if(r && !r.error) {
                    GlobalFunction.createLocalStorageEntry('user_info', r);
                    GlobalFunction['user_info'] = r;
                    //GlobalFunction.createCookie('user_info', JSON.stringify(r), res.expires_in || 1);
                }
                return res;
            });
        }
        return result;
    }

    isLoggedIn() {
        return !!localStorage.getItem('token');
    }

    async getAvatarUserLogin(id: any) {
      return await this._db.get(API.GET_FILES +'/'+ id);
    }

    logout() {
        return this._db.revokeToken();
    }
}



// WEBPACK FOOTER //
// ./src/app/common/services/authenticate.service.ts